<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Cafeteria</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's cafeteria page. Our school cafeteria is a hub of activity and an essential part of our school community. Our cafeteria provides nutritious and delicious meals for our students and staff and serves as a gathering place for socializing and relaxing during lunch breaks.</p>
                    <p class="inner-lead">Our school cafeteria is not just a place to eat but also a space to connect with other members of the school community. Our cafeteria is designed to be a welcoming environment where students can enjoy their meals and socialize with friends. Our experienced kitchen staff is committed to providing healthy, delicious meal options to meet the needs and preferences of all students.
                    </p>
                    <p class="inner-lead">Our school cafeteria is not just a place to eat but also a space to connect with other members of the school community. Our cafeteria is designed to be a welcoming environment where students can enjoy their meals and socialize with friends. Our experienced kitchen staff is committed to providing healthy, delicious meal options to meet the needs and preferences of all students.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>